import {onMount} from "@otto-ec/global-resources/dom";
import {runWithSpan} from "@otto-ec/global-resources/apm";
import {BrandSpotlight} from "./brandspotlight";

onMount(".promo-pdp-brandspotlight__container", (element) => {
    runWithSpan(() => {
        new BrandSpotlight(element);
    }, "ft3.promo-pdp-brandspotlight")
});
